export default __webpack_public_path__ + "static/media/City-day.dc5197bd.mp4";